module.exports = __webpack_public_path__ + "img/girl_selected.a9db3ad0.png";